import { motion } from "framer-motion";
import "./ChooseRole.css";
import Loginheader from "../../../components/loginheader/Loginheader";
import { useNavigate } from "react-router-dom";
import Hrimage from "../../../assests/hr.jpg";
import Employeeimage from "../../../assests/employee.jpg";
import Background from "../../../assests/hr_panel_back.png";
import { AuthContext } from "../../../context/AuthContext";
import { useContext } from "react";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.2,
      duration: 0.6,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 30 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
    },
  },
};

export default function ChooseRole() {
  const navigate = useNavigate();
  const { authData, backUrl } = useContext(AuthContext);
  const isMobile = window.innerWidth < 768;

  const handleHr = () => {
    if (authData.employee.is_hr === true && authData.employee?.is_superuser === true) {
      navigate("/hrdashboard");
    } else if (authData.employee.is_hr === true && authData.employee.role === 1) {
      navigate("/payroll_hr");
    }
    else if (authData.employee.is_hr === true && authData.employee.role === 2) {
      navigate("/payroll_hr");
    }
  };

  const handleEmployee = () => {
    if (authData?.employee?.is_superuser) {
      localStorage.setItem("Hrselected", "employee");
      navigate("/employee");
    }
    else if (authData?.employee?.is_hr && authData?.employee?.role === 2) {
      localStorage.setItem("Hrselected", "employee");
      navigate("/employee")
    }
    else if (authData?.employee?.is_hr && authData?.employee?.role === 1) {
      localStorage.setItem("Hrselected", "employee");
      navigate("/employee")
    }
    else {
      navigate("/employee");
    }

  };

  return (
    <>
      <Loginheader />
      <img id="hr-back" src={Background} alt="background" />
      <div className="container mt-5">

        <motion.div
          className="d-flex justify-content-center gap-5 flex-wrap"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.button
            className="role-option"
            variants={itemVariants}
            whileHover={{
              rotateX: 0,
              rotateY: 0,
              scale: 1.02,
              boxShadow: "0 12px 24px rgba(0, 0, 0, 0.2)",
              transition: { duration: 0.1 },
            }}
            whileTap={{ scale: 0.97, rotateX: 0, rotateY: 0 }}
            onClick={handleHr}
          >
            <img src={Hrimage} alt="HR" className="role-icon" />
            HR Panel
          </motion.button>

          <motion.button
            className="role-option"
            variants={itemVariants}
            whileHover={{
              rotateX: 0,
              rotateY: 0,
              scale: 1.02,
              boxShadow: "0 12px 24px rgba(0, 0, 0, 0.2)",
              transition: { duration: 0.1 },
            }}
            whileTap={{ scale: 0.97, rotateX: 0, rotateY: 0 }}
            onClick={handleEmployee}
          >
            <img src={Employeeimage} alt="Employee" className="role-icon" />
            Employee
          </motion.button>
        </motion.div>
      </div>
    </>
  );
}
